/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useEffect, useState } from "react";
import { Dialog, IconButton, CircularProgress } from "@mui/material";
import { DocumentArchiveDialogPanel } from "cms/documents/document-selector/dialog-archive/document-archive-dialog-panel";
import { DocumentArchiveDialogActions } from "cms/documents/document-selector/dialog-archive/document-archive-dialog-actions";
import { CloseOutlined } from "@ant-design/icons";
import { useDocuments } from "cms/documents/hooks/use-document";

const DocumentArchiveDialog = (props) => {
    
    const {
        open = false,
        setOpen,
        selectedDocument,
        onDocumentArchived,
    } = props;
    
    const [loading,setLoading] = useState(false);
    const [completed,setCompleted] = useState(false);
    const { archiveDocument } = useDocuments();
    
    useEffect(() => {
        setLoading(false);
        setCompleted(false);
    }, [selectedDocument, open]);

    const handleCancel = () => {
        setOpen(false);
    };
    const handleArchive = async () => {
        setLoading(true);
        const archived_doc = await archiveDocument(selectedDocument?.guid);
        setLoading(false);
        setCompleted(true);
        await onDocumentArchived(archived_doc);
    };

    return (
        <Fragment>
            <>
                <Dialog
                    open={open}
                    onClose={handleCancel}
                    fullWidth={true}
                    maxWidth="sm"
                    className="simplicity-document-selector-overlay"
                >
                    <div className="base-dialog">
                        <div className="simplicity-document-selector-window-title">
                            
                            Archive document
                            
                            <IconButton style={{ marginLeft: "auto" }}
                                onClick={handleCancel}
                            >
                                <CloseOutlined/>
                            </IconButton>
                        </div>
                        
                        <div className="simplicity-document-selector-window-content">
                            <div className="simplicity-document-selector-window-active">
                                
                                {!loading && !completed &&
                                    <DocumentArchiveDialogPanel
                                        selectedDocument={selectedDocument}
                                    />
                                }
                                {loading &&
                                    <div style={{
                                        display: "flex", flexDirection: "row",
                                        justifyContent: "center", alignItems: "center",
                                        width: "100%", padding: "16px", minHeight: "300px",
                                    }}
                                    >
                                        <CircularProgress color="secondary"/>
                                    </div>
                                }
                                {completed &&
                                    <div style={{
                                        display: "flex", flexDirection: "row",
                                        justifyContent: "center", alignItems: "center",
                                        width: "100%", padding: "16px", minHeight: "300px",
                                    }}
                                    >
                                        Completed.
                                    </div>
                                }
                                
                            </div>
                        </div>
                        
                        <DocumentArchiveDialogActions
                            loading={loading}
                            handleCancel={handleCancel}
                            handleArchive={handleArchive}
                        />
                        
                    </div>
                </Dialog>
            </>
        </Fragment>
    );
};

export { DocumentArchiveDialog };
